import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ListFilterComponent } from './list-filter.component';
import { MultiplePropertyFilterComponent } from './multiple-property-filter/multiple-property-filter.component';
import { StringFilterComponent } from './string-filter/string-filter.component';
import { DateFilterComponent } from './date-filter/date-filter.component';
import { ColumnHeaderComponent } from './column-header/column-header.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DocColumnHeaderComponent } from './doc-column-header/doc-column-header.component';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    NgxSliderModule
  ],
  declarations: [
    ListFilterComponent,
    MultiplePropertyFilterComponent,
    StringFilterComponent,
    DateFilterComponent,
    ColumnHeaderComponent,
    DocColumnHeaderComponent
  ],
  exports: [
    ListFilterComponent,
    ColumnHeaderComponent,
    DocColumnHeaderComponent
  ]
})
export class ListFilterModule { }
